// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"LoaderStyles_loaderWrapper__aJhN4"};